export const lessonProgressStatus = [
  {
    label: "Mastered", color: "bg-[#FFC300]", icon:
      <span className="material-symbols-outlined text-lg text-white">
        rewarded_ads
      </span>
  },
  {
    label: "Proficient", color: "bg-[#006FFF]", icon: <span className="material-symbols-outlined text-lg text-white">
      check
    </span>
  },
  { label: "Familiar", color: "bg-[#00BA1C]" },
  { label: "Attempted", color: "bg-[#FE7600]" },
  { label: "Not started", color: "bg-white" }
];